/* eslint-disable */
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export const QuestionOptionsFieldsFragmentDoc = gql`
    fragment QuestionOptionsFields on LibraryQuestionOptions {
  __typename
  ... on ScaledQuestionOptions {
    min
    max
  }
  ... on MultipleChoiceQuestionOptions {
    choices
  }
}
    `;
export const CheckInSlotFragmentDoc = gql`
    fragment CheckInSlot on CheckInSlot {
  id
  templateId
  order
  slotType
  staticQuestionId
  staticQuestion {
    id
    text
    questionType
    options {
      ...QuestionOptionsFields
    }
    enableTrends
  }
}
    ${QuestionOptionsFieldsFragmentDoc}`;
export const CheckInTemplateFragmentDoc = gql`
    fragment CheckInTemplate on CheckInTemplate {
  id
  name
  frequency
  churchId
  departmentId
  createdAt
  updatedAt
  deletedAt
  department {
    id
    name
  }
}
    `;
export const CheckInInstanceFragmentDoc = gql`
    fragment CheckInInstance on CheckInInstance {
  id
  templateId
  scheduledFor
  dueAt
  status
  createdAt
  updatedAt
  template {
    ...CheckInTemplate
  }
}
    ${CheckInTemplateFragmentDoc}`;
export const CheckInQuestionOptionsFieldsFragmentDoc = gql`
    fragment CheckInQuestionOptionsFields on CheckInQuestionOptions {
  __typename
  ... on ScaledQuestionOptions {
    min
    max
  }
  ... on MultipleChoiceQuestionOptions {
    choices
  }
}
    `;
export const CheckInQuestionFragmentDoc = gql`
    fragment CheckInQuestion on CheckInQuestion {
  id
  text
  questionType
  options {
    ...CheckInQuestionOptionsFields
  }
  enableTrends
  libraryQuestionId
  instanceId
}
    ${CheckInQuestionOptionsFieldsFragmentDoc}`;
export const CheckInResponseFragmentDoc = gql`
    fragment CheckInResponse on CheckInResponse {
  id
  instanceId
  personId
  submittedAt
  createdAt
  person {
    id
    name
    email
  }
  answers {
    id
    questionId
    answerValue
    question {
      ...CheckInQuestion
    }
  }
}
    ${CheckInQuestionFragmentDoc}`;
export const LibraryQuestionFragmentDoc = gql`
    fragment LibraryQuestion on LibraryQuestion {
  id
  text
  questionType
  options {
    ...QuestionOptionsFields
  }
  enableTrends
  churchId
  tags {
    id
    name
  }
}
    ${QuestionOptionsFieldsFragmentDoc}`;
export const LayoutGridItemFieldsFragmentDoc = gql`
    fragment LayoutGridItemFields on LayoutGridItem {
  i
  x
  y
  w
  h
  minW
  minH
  maxW
  maxH
  static
  isDraggable
  isResizable
  moved
}
    `;
export const DashboardLayoutFieldsFragmentDoc = gql`
    fragment DashboardLayoutFields on DashboardLayout {
  breakpoints {
    key
    items {
      ...LayoutGridItemFields
    }
  }
}
    ${LayoutGridItemFieldsFragmentDoc}`;
export const DashboardFragmentDoc = gql`
    fragment Dashboard on Dashboard {
  id
  name
  slug
  layout {
    ...DashboardLayoutFields
  }
}
    ${DashboardLayoutFieldsFragmentDoc}`;
export const SubDepartmentFragmentDoc = gql`
    fragment SubDepartment on PeopleDepartment {
  id
  name
  createdAt
  members(where: {deletedAt: {equals: null}, leftTeamAt: {equals: null}}) {
    id
  }
}
    `;
export const MemberFragmentDoc = gql`
    fragment Member on Membership {
  id
  type
  createdAt
  leftTeamAt
  person {
    id
    name
    email
    phone
  }
  customFieldValues(where: {deletedAt: {equals: null}}) {
    id
    value
    customFieldId
  }
  activity(where: {deletedAt: {equals: null}}, orderBy: {createdAt: desc}) {
    id
    update
    createdAt
    createdById
    createdBy {
      id
      person {
        id
        name
      }
    }
  }
}
    `;
export const ParentNamesFragmentDoc = gql`
    fragment ParentNames on PeopleDepartment {
  id
  name
}
    `;
export const ParentFieldsFragmentDoc = gql`
    fragment ParentFields on PeopleDepartment {
  fields: customFields(
    where: {deletedAt: {equals: null}, shareWithSubDepartments: {equals: true}}
  ) {
    id
    name
    fieldType
    options {
      options
    }
  }
}
    `;
export const ValueLinkedSourceFieldsFragmentDoc = gql`
    fragment ValueLinkedSourceFields on MetricLinkedSource {
  __typename
  ... on MetricLinkedSourcePcoList {
    listId
    listName
  }
  ... on MetricLinkedSourcePcoHeadcount {
    eventId
    eventName
    resolvedPeriodId
    resolvedTimeId
  }
  ... on MetricLinkedSourceOtherCard {
    resolvedCardId
    cardName
    resolvedSourceType
  }
  ... on MetricLinkedSourceSumOfValues {
    metricIds
  }
}
    `;
export const MetricValueFieldsFragmentDoc = gql`
    fragment MetricValueFields on MetricValue {
  ... on MetricValueString {
    stringValue: value
  }
  ... on MetricValueNumber {
    numberValue: value
  }
}
    `;
export const CardLayoutFieldsFragmentDoc = gql`
    fragment CardLayoutFields on CardLayout {
  breakpoints {
    key
    items {
      ...LayoutGridItemFields
    }
  }
}
    ${LayoutGridItemFieldsFragmentDoc}`;
export const WidgetSettingsFieldsFragmentDoc = gql`
    fragment WidgetSettingsFields on WidgetSettings {
  __typename
  ... on WidgetSettingsFormula {
    formulaExpression
    trafficLight {
      green
      red
    }
    unitType
    useTrafficLight
  }
  ... on WidgetSettingsGraph {
    lines {
      name
      metricId
      values {
        id
        name
        date
        value
      }
    }
  }
  ... on WidgetSettingsOther {
    data
  }
}
    `;
export const IntegrationSettingsFieldsFragmentDoc = gql`
    fragment IntegrationSettingsFields on IntegrationSettings {
  accessToken
  refreshToken
  source
}
    `;
export const IntegrationCachedDataFieldsFragmentDoc = gql`
    fragment IntegrationCachedDataFields on IntegrationCachedData {
  listsLastRefreshedAt
}
    `;
export const CustomFieldOptionsListFieldsFragmentDoc = gql`
    fragment CustomFieldOptionsListFields on CustomFieldOptions {
  options
}
    `;
export const PeopleGroupFragmentDoc = gql`
    fragment PeopleGroup on PeopleGroup {
  id
  name
}
    `;
export const PeopleIntervalFragmentDoc = gql`
    fragment PeopleInterval on PeopleInterval {
  id
  name
  start
  end
}
    `;
export const PersonIntervalFragmentDoc = gql`
    fragment PersonInterval on PersonInterval {
  id
  position {
    id
    name
  }
  person {
    name
    email
    phone
  }
}
    `;
export const DepartmentFragmentDoc = gql`
    fragment Department on PeopleDepartment {
  id
  name
  createdAt
  updatedAt
  leaders: members(
    where: {deletedAt: {equals: null}, leftTeamAt: {equals: null}, type: {equals: LEADER}}
  ) {
    id
    person {
      id
      name
    }
  }
}
    `;
export const PositionFragmentDoc = gql`
    fragment Position on Position {
  id
  name
  default
}
    `;
 const MeDocument = gql`
    query me {
  admin: me {
    id
    firstName
    lastName
    email
    teams(where: {NOT: {churchId: {equals: "ADMIN_CHURCH_ID"}}}) {
      church {
        id
        name
        icon
      }
    }
  }
  church: findUniqueChurch(where: {id: "ADMIN_CHURCH_ID"}) {
    id
    name
    icon
    slug
  }
}
    `;
 const UpdateUserDocument = gql`
    mutation updateUser($data: UserUpdateInput!, $id: String!) {
  data: updateOneUser(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const DashboardGuestDocument = gql`
    query dashboardGuest($churchSlug: String!, $dashboardSlug: String!) {
  dashboard: dashboardGuest(
    churchSlug: $churchSlug
    dashboardSlug: $dashboardSlug
  ) {
    id
  }
}
    `;
 const MagicDocument = gql`
    mutation magic($token: String!) {
  slug: magic(token: $token)
}
    `;
 const PeopleGuestDocument = gql`
    query peopleGuest {
  person: peopleGuest {
    id
    churchId
    membership(
      where: {deletedAt: {equals: null}, leftTeamAt: {equals: null}, type: {equals: LEADER}}
    ) {
      id
      type
      department {
        id
        name
        parent {
          id
          name
          parent {
            id
            name
            parent {
              id
              name
              parent {
                id
                name
                parent {
                  id
                  name
                  parent {
                    id
                    name
                    parent {
                      id
                      name
                      parent {
                        id
                        name
                        parent {
                          id
                          name
                          parent {
                            id
                            name
                            parent {
                              id
                              name
                              parent {
                                id
                                name
                                parent {
                                  id
                                  name
                                  parent {
                                    id
                                    name
                                    parent {
                                      id
                                      name
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        subDepartments {
          id
          name
          subDepartments {
            id
            name
            subDepartments {
              id
              name
              subDepartments {
                id
                name
                subDepartments {
                  id
                  name
                  subDepartments {
                    id
                    name
                    subDepartments {
                      id
                      name
                      subDepartments {
                        id
                        name
                        subDepartments {
                          id
                          name
                          subDepartments {
                            id
                            name
                            subDepartments {
                              id
                              name
                              subDepartments {
                                id
                                name
                                subDepartments {
                                  id
                                  name
                                  subDepartments {
                                    id
                                    name
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
 const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  data: login(email: $email, password: $password)
}
    `;
 const DashboardLoginDocument = gql`
    mutation dashboardLogin($dashboardId: String!, $password: String!) {
  data: dashboardLogin(dashboardId: $dashboardId, password: $password)
}
    `;
 const PeopleLoginDocument = gql`
    mutation peopleLogin($churchId: String!, $email: String!) {
  data: peopleLogin(churchId: $churchId, email: $email)
}
    `;
 const DevBypassDocument = gql`
    mutation devBypass($churchId: String!) {
  slug: devBypass(churchId: $churchId)
}
    `;
 const SignupDocument = gql`
    mutation signup($data: UserCreateInput!) {
  data: signup(data: $data)
}
    `;
 const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  data: forgotPassword(email: $email) {
    message
  }
}
    `;
 const ResetPasswordDocument = gql`
    mutation resetPassword($data: UserUpdateInput!, $resetPasswordToken: String!) {
  data: resetPassword(data: $data, resetPasswordToken: $resetPasswordToken)
}
    `;
 const UpdatePasswordDocument = gql`
    mutation updatePassword($currentPassword: String!, $password: String!) {
  complete: updatePassword(currentPassword: $currentPassword, password: $password)
}
    `;
 const UpdateEmailDocument = gql`
    mutation updateEmail($currentEmail: String!, $email: String!) {
  complete: updateEmail(currentEmail: $currentEmail, email: $email)
}
    `;
 const ChangeChurchDocument = gql`
    mutation changeChurch($churchId: String!) {
  data: changeChurch(churchId: $churchId)
}
    `;
 const CreateCardDocument = gql`
    mutation createCard($data: CardCreateInput!, $templateCardId: String!) {
  data: createOneCard(data: $data, templateCardId: $templateCardId) {
    id
    name
    createdAt
  }
}
    `;
 const GetValuesDocument = gql`
    query getValues($cardId: String!) {
  values: findManyMetricEntry(
    where: {cardId: {equals: $cardId}, deletedAt: {equals: null}}
    orderBy: {name: asc}
  ) {
    id
    name
    content
    metricId
    linkedSourceType
    linkedSource {
      ...ValueLinkedSourceFields
    }
    updatedAt
  }
}
    ${ValueLinkedSourceFieldsFragmentDoc}`;
 const GetCardValuesDataDocument = gql`
    query getCardValuesData($cardId: String!) {
  data: getCardValuesData(cardId: $cardId) {
    card {
      id
      name
      createdAt
      dashboardId
    }
    metricsWithEntries {
      metric {
        id
        order
      }
      valueRange {
        min
        max
      }
      entry {
        __typename
        ... on CardValuesEntryPcoHeadcount {
          id
          name
          content
          metricId
          linkedSourceType
          linkedConfig {
            __typename
            ... on MetricLinkedConfigPcoHeadcount {
              eventId
              periodOffset
              timeId
            }
          }
          description
          updatedAt
          linkedSource {
            eventId
            eventName
            resolvedPeriodId
            resolvedTimeId
          }
        }
        ... on CardValuesEntryPcoList {
          id
          name
          content
          metricId
          linkedSourceType
          linkedConfig {
            __typename
            ... on MetricLinkedConfigPcoList {
              listId
            }
          }
          description
          updatedAt
          linkedSource {
            listId
            listName
          }
        }
        ... on CardValuesEntryOtherCard {
          id
          name
          content
          metricId
          linkedSourceType
          linkedConfig {
            __typename
            ... on MetricLinkedConfigOtherCard {
              cardOffset
              dashboardId
              metricId
            }
          }
          description
          updatedAt
          linkedSource {
            resolvedCardId
            cardName
            resolvedSourceType
          }
        }
        ... on CardValuesEntrySumOfValues {
          id
          name
          content
          metricId
          linkedSourceType
          linkedConfig {
            __typename
            ... on MetricLinkedConfigSumOfValues {
              metricIds
            }
          }
          description
          updatedAt
          linkedSource {
            metricIds
          }
        }
        ... on CardValuesEntryUserInput {
          id
          name
          content
          metricId
          linkedSourceType
          linkedConfig {
            __typename
          }
          description
          updatedAt
          linkedSource {
            __typename
          }
        }
      }
    }
  }
}
    `;
 const GetDashboardMetricsWithLabelsDocument = gql`
    query getDashboardMetricsWithLabels($dashboardId: String!) {
  metrics: getDashboardMetricsWithLabels(dashboardId: $dashboardId) {
    metricId
    currentLabel
    order
  }
}
    `;
 const CreateOneMetricDocument = gql`
    mutation createOneMetric($data: MetricCreateInput!) {
  createOneMetric(data: $data) {
    id
  }
}
    `;
 const UpdateOneMetricDocument = gql`
    mutation updateOneMetric($data: MetricUpdateInput!, $where: MetricWhereUniqueInput!) {
  updateOneMetric(data: $data, where: $where) {
    id
  }
}
    `;
 const DeleteOneMetricDocument = gql`
    mutation deleteOneMetric($where: MetricWhereUniqueInput!) {
  deleteOneMetric(where: $where) {
    id
  }
}
    `;
 const GetMetricLabelVariantsDocument = gql`
    query getMetricLabelVariants($metricId: String!) {
  variants: getMetricLabelVariants(metricId: $metricId) {
    label
    cardName
    createdAt
  }
}
    `;
 const MergeMetricLabelDocument = gql`
    mutation mergeMetricLabel($metricId: String!, $fromLabel: String!, $toLabel: String!) {
  mergeMetricLabel(metricId: $metricId, fromLabel: $fromLabel, toLabel: $toLabel) {
    updatedCount
  }
}
    `;
 const GetCardBasicsDocument = gql`
    query getCardBasics($id: String!) {
  card: findUniqueCard(where: {id: $id}) {
    id
    name
    dashboard {
      id
      name
      slug
      public
      church {
        slug
      }
    }
  }
}
    `;
 const GetCardDocument = gql`
    query getCard($id: String!) {
  card: findUniqueCard(where: {id: $id}) {
    id
    name
    layout {
      ...CardLayoutFields
    }
    createdAt
    dashboardId
    dashboard {
      id
      name
      slug
    }
    widgets(where: {deletedAt: {equals: null}}) {
      id
      name
      type
      settings {
        ...WidgetSettingsFields
      }
    }
    entries(where: {deletedAt: {equals: null}}, orderBy: {name: asc}) {
      id
      name
      linkedSourceType
      linkedSource {
        ...ValueLinkedSourceFields
      }
      content
      description
      metricId
      updatedAt
    }
  }
}
    ${CardLayoutFieldsFragmentDoc}
${WidgetSettingsFieldsFragmentDoc}
${ValueLinkedSourceFieldsFragmentDoc}`;
 const UpdateCardDocument = gql`
    mutation updateCard($data: CardUpdateInput!, $id: String) {
  data: updateOneCard(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const DeleteCardDocument = gql`
    mutation deleteCard($id: String) {
  deleteOneCard(where: {id: $id}) {
    id
  }
}
    `;
 const GetLinesDocument = gql`
    query getLines($ids: [String], $createdAt: DateTime) {
  data: findManyMetricEntry(
    where: {card: {is: {deletedAt: {equals: null}, createdAt: {lte: $createdAt}}}, metric: {is: {id: {in: $ids}}}, deletedAt: {equals: null}}
    orderBy: [{card: {createdAt: asc}}]
  ) {
    id
    metricId
    content
    name
    card {
      name
    }
  }
}
    `;
 const GetCardsDocument = gql`
    query getCards($dashboardId: String!) {
  cards: findManyCard(
    args: {where: {dashboardId: {equals: $dashboardId}}, orderBy: {createdAt: desc}}
  ) {
    id
    name
  }
}
    `;
 const GetCardValuesDocument = gql`
    query getCardValues($id: String!) {
  card: findUniqueCard(where: {id: $id}) {
    id
    name
    createdAt
    dashboardId
    dashboard {
      id
      name
      slug
    }
    entries(where: {deletedAt: {equals: null}}, orderBy: {name: asc}) {
      id
      name
      linkedSourceType
      linkedSource {
        ...ValueLinkedSourceFields
      }
      content
      description
      updatedAt
      metricId
      metric {
        id
        linkedType
        linkedConfig {
          __typename
          ... on MetricLinkedConfigPcoList {
            listId
          }
          ... on MetricLinkedConfigOtherCard {
            cardOffset
            metricId
            dashboardId
          }
          ... on MetricLinkedConfigPcoHeadcount {
            eventId
            timeId
            periodOffset
          }
          ... on MetricLinkedConfigSumOfValues {
            metricIds
          }
        }
        entries(
          where: {deletedAt: {equals: null}}
          orderBy: {createdAt: desc}
          take: 10
        ) {
          content
        }
      }
    }
  }
}
    ${ValueLinkedSourceFieldsFragmentDoc}`;
 const GetCardSyncValuesDocument = gql`
    query getCardSyncValues($id: String!) {
  card: findUniqueCard(where: {id: $id}) {
    id
    name
    createdAt
    dashboardId
    dashboard {
      id
      name
      slug
    }
    entries(where: {deletedAt: {equals: null}}, orderBy: {name: asc}) {
      id
      name
      linkedSourceType
      linkedSource {
        ...ValueLinkedSourceFields
      }
      content
      description
    }
  }
}
    ${ValueLinkedSourceFieldsFragmentDoc}`;
 const GetCheckInTemplatesDocument = gql`
    query getCheckInTemplates($churchId: String!) {
  templates: findManyCheckInTemplate(
    args: {where: {churchId: {equals: $churchId}, deletedAt: {equals: null}}, orderBy: {createdAt: desc}}
  ) {
    id
    name
    frequency
    churchId
    departmentId
    createdAt
    updatedAt
    deletedAt
    department {
      id
      name
    }
    slots(where: {deletedAt: {equals: null}}, orderBy: {order: asc}) {
      id
      order
    }
  }
}
    `;
 const GetCheckInTemplateDocument = gql`
    query getCheckInTemplate($id: String!) {
  template: findUniqueCheckInTemplate(where: {id: $id}) {
    ...CheckInTemplate
    slots(where: {deletedAt: {equals: null}}, orderBy: {order: asc}) {
      ...CheckInSlot
    }
    instances(where: {deletedAt: {equals: null}}, orderBy: {scheduledFor: desc}) {
      ...CheckInInstance
    }
  }
}
    ${CheckInTemplateFragmentDoc}
${CheckInSlotFragmentDoc}
${CheckInInstanceFragmentDoc}`;
 const GetCheckInInstanceDocument = gql`
    query getCheckInInstance($id: String!) {
  instance: findUniqueCheckInInstance(where: {id: $id}) {
    ...CheckInInstance
    questions(where: {deletedAt: {equals: null}}) {
      ...CheckInQuestion
    }
    responses(where: {submittedAt: {not: {equals: null}}}) {
      ...CheckInResponse
    }
  }
}
    ${CheckInInstanceFragmentDoc}
${CheckInQuestionFragmentDoc}
${CheckInResponseFragmentDoc}`;
 const GetMyCheckInsDocument = gql`
    query getMyCheckIns($personId: String!, $churchId: String!) {
  instances: findManyCheckInInstance(
    where: {deletedAt: {equals: null}, template: {is: {churchId: {equals: $churchId}}}}
    orderBy: {scheduledFor: desc}
  ) {
    ...CheckInInstance
    questions(where: {deletedAt: {equals: null}}) {
      ...CheckInQuestion
    }
  }
}
    ${CheckInInstanceFragmentDoc}
${CheckInQuestionFragmentDoc}`;
 const GetCheckInResponsesDocument = gql`
    query getCheckInResponses($instanceId: String!, $personId: String!) {
  responses: findManyCheckInResponse(
    where: {instanceId: {equals: $instanceId}, submittedAt: {not: {equals: null}}}
    orderBy: [{submittedAt: {sort: desc}}]
  ) {
    ...CheckInResponse
  }
}
    ${CheckInResponseFragmentDoc}`;
 const GetCheckInTrendsDocument = gql`
    query getCheckInTrends($questionId: String!, $instanceIds: [String!]) {
  trends: getCheckInTrends(questionId: $questionId, instanceIds: $instanceIds) {
    instanceId
    scheduledFor
    value
    submittedAt
  }
}
    `;
 const GetLibraryQuestionsDocument = gql`
    query getLibraryQuestions($churchId: String) {
  questions: findManyLibraryQuestion(
    args: {where: {deletedAt: {equals: null}, OR: [{churchId: {equals: $churchId}}, {churchId: {equals: null}}]}, orderBy: {createdAt: desc}}
  ) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
 const GetLibraryQuestionDocument = gql`
    query getLibraryQuestion($id: String!) {
  question: findUniqueLibraryQuestion(where: {id: $id}) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
 const CreateCheckInTemplateDocument = gql`
    mutation createCheckInTemplate($data: CheckInTemplateCreateInput!) {
  template: createOneCheckInTemplate(data: $data) {
    ...CheckInTemplate
  }
}
    ${CheckInTemplateFragmentDoc}`;
 const UpdateCheckInTemplateDocument = gql`
    mutation updateCheckInTemplate($data: CheckInTemplateUpdateInput!, $id: String!) {
  template: updateOneCheckInTemplate(data: $data, where: {id: $id}) {
    ...CheckInTemplate
  }
}
    ${CheckInTemplateFragmentDoc}`;
 const CreateCheckInInstanceDocument = gql`
    mutation createCheckInInstance($templateId: String!, $scheduledFor: DateTime!, $dueAt: DateTime!) {
  instance: createOneCheckInInstance(
    data: {template: {connect: {id: $templateId}}, scheduledFor: $scheduledFor, dueAt: $dueAt, status: DRAFT, createdAt: $scheduledFor, updatedAt: $scheduledFor}
  ) {
    ...CheckInInstance
  }
}
    ${CheckInInstanceFragmentDoc}`;
 const UpdateCheckInInstanceDocument = gql`
    mutation updateCheckInInstance($data: CheckInInstanceUpdateInput!, $id: String!) {
  instance: updateOneCheckInInstance(data: $data, where: {id: $id}) {
    ...CheckInInstance
  }
}
    ${CheckInInstanceFragmentDoc}`;
 const SelectDynamicQuestionsDocument = gql`
    mutation selectDynamicQuestions($instanceId: String!, $questions: [SelectDynamicQuestionInput!]!) {
  instance: selectDynamicQuestions(instanceId: $instanceId, questions: $questions) {
    ...CheckInInstance
  }
}
    ${CheckInInstanceFragmentDoc}`;
 const SubmitCheckInResponseDocument = gql`
    mutation submitCheckInResponse($instanceId: String!, $personId: String!, $answers: [CheckInAnswerSubmitInput!]!) {
  response: submitCheckInResponse(
    instanceId: $instanceId
    personId: $personId
    answers: $answers
  ) {
    ...CheckInResponse
  }
}
    ${CheckInResponseFragmentDoc}`;
 const ToggleFavoriteQuestionDocument = gql`
    mutation toggleFavoriteQuestion($personId: String!, $libraryQuestionId: String!) {
  result: toggleFavoriteQuestion(
    personId: $personId
    libraryQuestionId: $libraryQuestionId
  ) {
    isFavorite
  }
}
    `;
 const CreateCheckInSlotDocument = gql`
    mutation createCheckInSlot($data: CheckInSlotCreateInput!) {
  slot: createOneCheckInSlot(data: $data) {
    ...CheckInSlot
  }
}
    ${CheckInSlotFragmentDoc}`;
 const UpdateCheckInSlotDocument = gql`
    mutation updateCheckInSlot($data: CheckInSlotUpdateInput!, $id: String!) {
  slot: updateOneCheckInSlot(data: $data, where: {id: $id}) {
    ...CheckInSlot
  }
}
    ${CheckInSlotFragmentDoc}`;
 const DeleteCheckInSlotDocument = gql`
    mutation deleteCheckInSlot($id: String!) {
  slot: deleteOneCheckInSlot(where: {id: $id}) {
    ...CheckInSlot
  }
}
    ${CheckInSlotFragmentDoc}`;
 const DeleteCheckInTemplateDocument = gql`
    mutation deleteCheckInTemplate($id: String!) {
  template: deleteOneCheckInTemplate(where: {id: $id}) {
    ...CheckInTemplate
  }
}
    ${CheckInTemplateFragmentDoc}`;
 const CreateLibraryQuestionDocument = gql`
    mutation createLibraryQuestion($data: LibraryQuestionCreateInput!) {
  question: createOneLibraryQuestion(data: $data) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
 const UpdateLibraryQuestionDocument = gql`
    mutation updateLibraryQuestion($data: LibraryQuestionUpdateInput!, $id: String!) {
  question: updateOneLibraryQuestion(data: $data, where: {id: $id}) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
 const DeleteLibraryQuestionDocument = gql`
    mutation deleteLibraryQuestion($id: String!) {
  question: deleteOneLibraryQuestion(where: {id: $id}) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
 const GetQuestionTagsDocument = gql`
    query getQuestionTags($churchId: String!) {
  tags: findManyQuestionTag(
    args: {where: {churchId: {equals: $churchId}, deletedAt: {equals: null}}, orderBy: {createdAt: desc}}
  ) {
    id
    name
    churchId
    createdAt
    libraryQuestions {
      id
    }
  }
}
    `;
 const CreateQuestionTagDocument = gql`
    mutation createQuestionTag($data: QuestionTagCreateInput!) {
  tag: createOneQuestionTag(data: $data) {
    id
    name
    churchId
    createdAt
  }
}
    `;
 const UpdateQuestionTagDocument = gql`
    mutation updateQuestionTag($data: QuestionTagUpdateInput!, $id: String!) {
  tag: updateOneQuestionTag(data: $data, where: {id: $id}) {
    id
    name
    churchId
    createdAt
  }
}
    `;
 const DeleteQuestionTagDocument = gql`
    mutation deleteQuestionTag($id: String!) {
  tag: deleteOneQuestionTag(where: {id: $id}) {
    id
  }
}
    `;
 const CreateChurchDocument = gql`
    mutation createChurch($data: ChurchCreateInput!) {
  createOneChurch(data: $data)
}
    `;
 const GetChurchBySlugDocument = gql`
    query getChurchBySlug($slug: String!) {
  church: findUniqueChurch(where: {slug: $slug}) {
    id
    name
    slug
    icon
    logo
    password
  }
}
    `;
 const GetChurchSettingsDocument = gql`
    query getChurchSettings {
  church: findUniqueChurch(where: {id: "ADMIN_CHURCH_ID"}) {
    id
    name
    slug
    password
    integrations(where: {deletedAt: {equals: null}}) {
      id
      type
      settings {
        ...IntegrationSettingsFields
      }
      cachedData {
        ...IntegrationCachedDataFields
      }
    }
  }
}
    ${IntegrationSettingsFieldsFragmentDoc}
${IntegrationCachedDataFieldsFragmentDoc}`;
 const UpdateChurchDocument = gql`
    mutation updateChurch($data: ChurchUpdateInput!) {
  data: updateOneChurch(where: {id: "ADMIN_CHURCH_ID"}, data: $data) {
    id
    name
    slug
    integrations(where: {deletedAt: {equals: null}}) {
      id
      type
      settings {
        ...IntegrationSettingsFields
      }
      cachedData {
        ...IntegrationCachedDataFields
      }
    }
  }
}
    ${IntegrationSettingsFieldsFragmentDoc}
${IntegrationCachedDataFieldsFragmentDoc}`;
 const DeleteIntegrationDocument = gql`
    mutation deleteIntegration($id: String) {
  deleteOneIntegration(where: {id: $id}) {
    id
  }
}
    `;
 const GetDashboardsPageDocument = gql`
    query getDashboardsPage {
  dashboards: findManyDashboard(
    args: {where: {church: {is: {id: {equals: "ADMIN_CHURCH_ID"}}}, deletedAt: {equals: null}}, orderBy: {name: asc}}
  ) {
    id
    name
    slug
    createdAt
  }
  church: findUniqueChurch(where: {id: "ADMIN_CHURCH_ID"}) {
    slug
  }
}
    `;
 const GetDashboardsBySlugDocument = gql`
    query getDashboardsBySlug($slug: String!) {
  dashboards: findManyDashboard(
    args: {where: {church: {is: {slug: {equals: $slug}}}, deletedAt: {equals: null}, public: {equals: true}}, orderBy: {name: asc}}
  ) {
    id
    name
    slug
    createdAt
  }
}
    `;
 const CreateDashboardDocument = gql`
    mutation createDashboard($data: DashboardCreateInput!) {
  data: createOneDashboard(data: $data) {
    id
    slug
  }
}
    `;
 const GetDashboardDocument = gql`
    query getDashboard($slug: String!) {
  dashboard: findUniqueDashboard(
    where: {slug_churchId: {slug: $slug, churchId: "ADMIN_CHURCH_ID"}}
  ) {
    ...Dashboard
    public
    password
    cards(where: {deletedAt: {equals: null}}, orderBy: {createdAt: desc}) {
      id
      name
      createdAt
    }
  }
}
    ${DashboardFragmentDoc}`;
 const UpdateDashboardDocument = gql`
    mutation updateDashboard($data: DashboardUpdateInput!, $id: String) {
  data: updateOneDashboard(data: $data, where: {id: $id}) {
    ...Dashboard
  }
}
    ${DashboardFragmentDoc}`;
 const GetDashboardByChurchSlugDocument = gql`
    query getDashboardByChurchSlug($churchSlug: String!, $dashboardSlug: String!) {
  church: findUniqueChurch(where: {slug: $churchSlug}) {
    id
    name
    dashboard(where: {slug: {equals: $dashboardSlug}, deletedAt: {equals: null}}) {
      ...Dashboard
      password
      cards(where: {deletedAt: {equals: null}}, orderBy: {createdAt: desc}) {
        id
        name
        createdAt
      }
    }
  }
}
    ${DashboardFragmentDoc}`;
 const DeleteDashboardDocument = gql`
    mutation deleteDashboard($id: String) {
  deleteOneDashboard(where: {id: $id}) {
    id
  }
}
    `;
 const GetDepartmentsDocument = gql`
    query getDepartments($id: String!) {
  departments: findManyPeopleDepartment(
    args: {where: {church: {is: {id: {equals: $id}}}, deletedAt: {equals: null}}}
  ) {
    _key: id
    name
    father: parentId
    createdAt
    updatedAt
    subDepartments {
      id
    }
  }
}
    `;
 const CreateDepartmentDocument = gql`
    mutation createDepartment($data: PeopleDepartmentCreateInput!) {
  data: createOnePeopleDepartment(data: $data) {
    id
  }
}
    `;
 const UpdateDepartmentDocument = gql`
    mutation updateDepartment($data: PeopleDepartmentUpdateInput!, $id: String) {
  data: updateOnePeopleDepartment(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const DeleteDepartmentDocument = gql`
    mutation deleteDepartment($id: String!) {
  data: deleteOnePeopleDepartment(where: {id: $id}) {
    id
  }
}
    `;
 const GetDepartmentGraphDocument = gql`
    query getDepartmentGraph($id: String!) {
  departments: findManyPeopleDepartment(
    parentIdNull: true
    args: {where: {church: {is: {id: {equals: $id}}}, deletedAt: {equals: null}}, orderBy: {createdAt: asc}}
  ) {
    ...Department
    children: subDepartments(where: {deletedAt: {equals: null}}) {
      ...Department
      children: subDepartments(where: {deletedAt: {equals: null}}) {
        ...Department
        children: subDepartments(where: {deletedAt: {equals: null}}) {
          ...Department
          children: subDepartments(where: {deletedAt: {equals: null}}) {
            ...Department
            children: subDepartments(where: {deletedAt: {equals: null}}) {
              ...Department
              children: subDepartments(where: {deletedAt: {equals: null}}) {
                ...Department
                children: subDepartments(where: {deletedAt: {equals: null}}) {
                  ...Department
                  children: subDepartments(where: {deletedAt: {equals: null}}) {
                    ...Department
                    children: subDepartments(where: {deletedAt: {equals: null}}) {
                      ...Department
                      children: subDepartments(where: {deletedAt: {equals: null}}) {
                        ...Department
                        children: subDepartments(where: {deletedAt: {equals: null}}) {
                          ...Department
                          children: subDepartments(where: {deletedAt: {equals: null}}) {
                            ...Department
                            children: subDepartments(where: {deletedAt: {equals: null}}) {
                              ...Department
                              children: subDepartments(where: {deletedAt: {equals: null}}) {
                                ...Department
                                children: subDepartments(where: {deletedAt: {equals: null}}) {
                                  ...Department
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DepartmentFragmentDoc}`;
 const GetDepartmentDocument = gql`
    query getDepartment($id: String!) {
  department: findUniquePeopleDepartment(where: {id: $id}) {
    id
    name
    parentId
    createdAt
  }
}
    `;
 const GetDepartmentMembersDocument = gql`
    query getDepartmentMembers($id: String!, $leftTeamAt: DateTimeNullableFilter, $churchId: String!) {
  departmentMembers: findUniquePeopleDepartment(
    where: {id: $id, church: {is: {id: {equals: $churchId}}}}
  ) {
    subDepartments {
      leaders: members(
        where: {deletedAt: {equals: null}, leftTeamAt: $leftTeamAt, type: {equals: LEADER}}
      ) {
        ...Member
      }
    }
    members(
      where: {leftTeamAt: $leftTeamAt, deletedAt: {equals: null}}
      orderBy: {type: desc}
    ) {
      ...Member
      reasonForLeaving
      note
    }
  }
}
    ${MemberFragmentDoc}`;
 const GetSubDepartmentsDocument = gql`
    query getSubDepartments($id: String!, $churchId: String!) {
  subDepartments: findUniquePeopleDepartment(
    where: {id: $id, churchId: {equals: $churchId}}
  ) {
    subDepartments(where: {deletedAt: {equals: null}}) {
      ...SubDepartment
    }
  }
}
    ${SubDepartmentFragmentDoc}`;
 const GetParentNamesDocument = gql`
    query getParentNames($id: String!, $churchId: String!) {
  department: findUniquePeopleDepartment(
    where: {id: $id, churchId: {equals: $churchId}}
  ) {
    id
    name
    parent {
      ...ParentNames
      parent {
        ...ParentNames
        parent {
          ...ParentNames
          parent {
            ...ParentNames
            parent {
              ...ParentNames
              parent {
                ...ParentNames
                parent {
                  ...ParentNames
                  parent {
                    ...ParentNames
                    parent {
                      ...ParentNames
                      parent {
                        ...ParentNames
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ParentNamesFragmentDoc}`;
 const GetNamesWithParentsDocument = gql`
    query getNamesWithParents($churchId: String!) {
  departments: findManyPeopleDepartment(
    args: {where: {churchId: {equals: $churchId}}}
  ) {
    id
    name
    parent {
      ...ParentNames
      parent {
        ...ParentNames
        parent {
          ...ParentNames
          parent {
            ...ParentNames
            parent {
              ...ParentNames
              parent {
                ...ParentNames
                parent {
                  ...ParentNames
                  parent {
                    ...ParentNames
                    parent {
                      ...ParentNames
                      parent {
                        ...ParentNames
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ParentNamesFragmentDoc}`;
 const GetSubDepartmentNamesDocument = gql`
    query getSubDepartmentNames($id: String!, $churchId: String!) {
  subNames: findUniquePeopleDepartment(
    where: {id: $id, churchId: {equals: $churchId}}
  ) {
    id
    name
    subDepartments {
      ...ParentNames
      subDepartments {
        ...ParentNames
        subDepartments {
          ...ParentNames
          subDepartments {
            ...ParentNames
            subDepartments {
              ...ParentNames
              subDepartments {
                ...ParentNames
                subDepartments {
                  ...ParentNames
                  subDepartments {
                    ...ParentNames
                    subDepartments {
                      ...ParentNames
                      subDepartments {
                        ...ParentNames
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ParentNamesFragmentDoc}`;
 const GetFieldsDocument = gql`
    query getFields($id: String!, $churchId: String!) {
  fieldDepartment: findUniquePeopleDepartment(
    where: {id: $id, churchId: {equals: $churchId}}
  ) {
    id
    name
    fields: customFields(where: {deletedAt: {equals: null}}) {
      id
      name
      fieldType
      options {
        options
      }
      shareWithSubDepartments
      departmentId
    }
    parent {
      ...ParentFields
      parent {
        ...ParentFields
        parent {
          ...ParentFields
          parent {
            ...ParentFields
            parent {
              ...ParentFields
              parent {
                ...ParentFields
                parent {
                  ...ParentFields
                  parent {
                    ...ParentFields
                    parent {
                      ...ParentFields
                      parent {
                        ...ParentFields
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ParentFieldsFragmentDoc}`;
 const CreateCustomFieldDocument = gql`
    mutation createCustomField($data: CustomFieldCreateInput!) {
  data: createOneCustomField(data: $data) {
    id
  }
}
    `;
 const UpdateCustomFieldDocument = gql`
    mutation updateCustomField($data: CustomFieldUpdateInput!, $id: String) {
  data: updateOneCustomField(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const DeleteCustomFieldDocument = gql`
    mutation deleteCustomField($id: String!) {
  data: deleteOneCustomField(where: {id: $id}) {
    id
  }
}
    `;
 const CreateMemberDocument = gql`
    mutation createMember($data: MembershipCreateInput!) {
  data: createOneMembership(data: $data) {
    id
  }
}
    `;
 const UpdateMemberDocument = gql`
    mutation updateMember($id: String!, $data: MembershipUpdateInput!) {
  data: updateOneMembership(where: {id: $id}, data: $data) {
    id
  }
}
    `;
 const DeleteMemberDocument = gql`
    mutation deleteMember($id: String!) {
  data: deleteOneMembership(where: {id: $id}) {
    id
  }
}
    `;
 const UpdateManyMembersDocument = gql`
    mutation updateManyMembers($data: MembershipUpdateInput!, $where: MembershipWhereInput) {
  updateManyMembership(data: $data, where: $where) {
    count
  }
}
    `;
 const CreateActivityDocument = gql`
    mutation createActivity($data: ActivityCreateInput!) {
  data: createOneActivity(data: $data) {
    id
    createdById
    createdAt
  }
}
    `;
 const UpdateActivityDocument = gql`
    mutation updateActivity($id: String!, $data: ActivityUpdateInput!) {
  data: updateOneActivity(where: {id: $id}, data: $data) {
    id
  }
}
    `;
 const DeleteActivityDocument = gql`
    mutation deleteActivity($id: String!) {
  data: deleteOneActivity(where: {id: $id}) {
    id
  }
}
    `;
 const UpdatePersonIntervalDocument = gql`
    mutation updatePersonInterval($data: PersonIntervalUpdateInput!, $id: String) {
  data: updateOnePersonInterval(data: $data, where: {id: $id}) {
    ...PersonInterval
  }
}
    ${PersonIntervalFragmentDoc}`;
 const DeletePersonDocument = gql`
    mutation deletePerson($id: String!) {
  data: deleteOnePerson(where: {id: $id}) {
    id
  }
}
    `;
 const GetDuplicatesDocument = gql`
    query getDuplicates {
  data: getDuplicates(orderBy: {name: asc}) {
    id
    name
    email
    phone
    integrationId
    createdAt
    personInterval {
      id
    }
  }
}
    `;
 const GetReportsDocument = gql`
    query getReports($churchId: String!) {
  reports: findManyReport(
    args: {where: {churchId: {equals: $churchId}, deletedAt: {equals: null}}, orderBy: {name: asc}}
  ) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
 const GetReportInfoDocument = gql`
    query getReportInfo($id: String!) {
  report: findUniqueReport(where: {id: $id}) {
    id
    name
    startDate
    endDate
    departments(where: {deletedAt: {equals: null}}) {
      id
    }
  }
}
    `;
 const GetReportMembersDocument = gql`
    query getReportMembers($startDate: DateTime!, $endDate: DateTime!, $departments: [String!]) {
  members: findManyMembership(
    args: {where: {AND: [{createdAt: {lte: $endDate}}, {OR: [{leftTeamAt: null}, {leftTeamAt: {gte: $startDate}}]}, {departmentId: {in: $departments}}], deletedAt: null}}
  ) {
    id
    departmentId
    createdAt
    leftTeamAt
    reasonForLeaving
    note
    person {
      id
      name
    }
  }
}
    `;
 const CreateReportDocument = gql`
    mutation createReport($data: ReportCreateInput!) {
  data: createOneReport(data: $data) {
    id
  }
}
    `;
 const UpdateReportDocument = gql`
    mutation updateReport($data: ReportUpdateInput!, $id: String) {
  data: updateOneReport(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const DeleteReportDocument = gql`
    mutation deleteReport($id: String!) {
  data: deleteOneReport(where: {id: $id}) {
    id
  }
}
    `;
 const GetUsersDocument = gql`
    query getUsers {
  users: findManyUser(
    where: {teams: {some: {churchId: {equals: "ADMIN_CHURCH_ID"}}}, deletedAt: {equals: null}}
    orderBy: {firstName: {sort: asc}}
  ) {
    id
    firstName
    lastName
    email
    teams(where: {churchId: {equals: "ADMIN_CHURCH_ID"}}) {
      role
    }
  }
}
    `;
 const DeleteTeamMemberDocument = gql`
    mutation deleteTeamMember($userId: String!) {
  deleteOneTeam(
    where: {churchId_userId: {churchId: "ADMIN_CHURCH_ID", userId: $userId}}
  ) {
    userId
    churchId
  }
}
    `;
 const InviteMemberDocument = gql`
    mutation inviteMember($email: String!, $role: String!) {
  inviteMember(email: $email, role: $role)
}
    `;
 const CreateWidgetDocument = gql`
    mutation createWidget($data: WidgetCreateInput!, $cardId: String!) {
  data: createOneWidget(data: $data, cardId: $cardId) {
    id
  }
}
    `;
 const UpdateWidgetDocument = gql`
    mutation updateWidget($data: WidgetUpdateInput!, $id: String!, $cardId: String!) {
  data: updateOneWidget(data: $data, where: {id: $id}, cardId: $cardId) {
    id
  }
}
    `;
 const DeleteWidgetDocument = gql`
    mutation deleteWidget($id: String!, $cardId: String!) {
  data: deleteOneWidget(where: {id: $id}, cardId: $cardId) {
    id
  }
}
    `;
 const CreateMetricEntryDocument = gql`
    mutation createMetricEntry($data: CreateMetricEntryDataInput!, $cardId: String!) {
  data: createOneMetricEntry(data: $data, cardId: $cardId) {
    id
  }
}
    `;
 const UpdateMetricEntryDocument = gql`
    mutation updateMetricEntry($data: UpdateMetricEntryDataInput!, $id: String!, $cardId: String!) {
  data: updateOneMetricEntry(data: $data, where: {id: $id}, cardId: $cardId) {
    id
  }
}
    `;
 const UpdateMultipleMetricEntriesDocument = gql`
    mutation updateMultipleMetricEntries($data: [MetricEntryUpdateWithWhereInput!], $cardId: String!) {
  data: updateMultipleMetricEntries(data: $data, cardId: $cardId)
}
    `;
 const DeleteMetricEntryDocument = gql`
    mutation deleteMetricEntry($id: String!, $cardId: String!) {
  data: deleteOneMetricEntry(where: {id: $id}, cardId: $cardId) {
    id
  }
}
    `;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    me(variables?: MeQueryVariables, options?: C): Promise<MeQuery> {
      return requester<MeQuery, MeQueryVariables>(MeDocument, variables, options) as Promise<MeQuery>;
    },
    updateUser(variables: UpdateUserMutationVariables, options?: C): Promise<UpdateUserMutation> {
      return requester<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables, options) as Promise<UpdateUserMutation>;
    },
    dashboardGuest(variables: DashboardGuestQueryVariables, options?: C): Promise<DashboardGuestQuery> {
      return requester<DashboardGuestQuery, DashboardGuestQueryVariables>(DashboardGuestDocument, variables, options) as Promise<DashboardGuestQuery>;
    },
    magic(variables: MagicMutationVariables, options?: C): Promise<MagicMutation> {
      return requester<MagicMutation, MagicMutationVariables>(MagicDocument, variables, options) as Promise<MagicMutation>;
    },
    peopleGuest(variables?: PeopleGuestQueryVariables, options?: C): Promise<PeopleGuestQuery> {
      return requester<PeopleGuestQuery, PeopleGuestQueryVariables>(PeopleGuestDocument, variables, options) as Promise<PeopleGuestQuery>;
    },
    login(variables: LoginMutationVariables, options?: C): Promise<LoginMutation> {
      return requester<LoginMutation, LoginMutationVariables>(LoginDocument, variables, options) as Promise<LoginMutation>;
    },
    dashboardLogin(variables: DashboardLoginMutationVariables, options?: C): Promise<DashboardLoginMutation> {
      return requester<DashboardLoginMutation, DashboardLoginMutationVariables>(DashboardLoginDocument, variables, options) as Promise<DashboardLoginMutation>;
    },
    peopleLogin(variables: PeopleLoginMutationVariables, options?: C): Promise<PeopleLoginMutation> {
      return requester<PeopleLoginMutation, PeopleLoginMutationVariables>(PeopleLoginDocument, variables, options) as Promise<PeopleLoginMutation>;
    },
    devBypass(variables: DevBypassMutationVariables, options?: C): Promise<DevBypassMutation> {
      return requester<DevBypassMutation, DevBypassMutationVariables>(DevBypassDocument, variables, options) as Promise<DevBypassMutation>;
    },
    signup(variables: SignupMutationVariables, options?: C): Promise<SignupMutation> {
      return requester<SignupMutation, SignupMutationVariables>(SignupDocument, variables, options) as Promise<SignupMutation>;
    },
    forgotPassword(variables: ForgotPasswordMutationVariables, options?: C): Promise<ForgotPasswordMutation> {
      return requester<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, variables, options) as Promise<ForgotPasswordMutation>;
    },
    resetPassword(variables: ResetPasswordMutationVariables, options?: C): Promise<ResetPasswordMutation> {
      return requester<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, variables, options) as Promise<ResetPasswordMutation>;
    },
    updatePassword(variables: UpdatePasswordMutationVariables, options?: C): Promise<UpdatePasswordMutation> {
      return requester<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, variables, options) as Promise<UpdatePasswordMutation>;
    },
    updateEmail(variables: UpdateEmailMutationVariables, options?: C): Promise<UpdateEmailMutation> {
      return requester<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, variables, options) as Promise<UpdateEmailMutation>;
    },
    changeChurch(variables: ChangeChurchMutationVariables, options?: C): Promise<ChangeChurchMutation> {
      return requester<ChangeChurchMutation, ChangeChurchMutationVariables>(ChangeChurchDocument, variables, options) as Promise<ChangeChurchMutation>;
    },
    createCard(variables: CreateCardMutationVariables, options?: C): Promise<CreateCardMutation> {
      return requester<CreateCardMutation, CreateCardMutationVariables>(CreateCardDocument, variables, options) as Promise<CreateCardMutation>;
    },
    getValues(variables: GetValuesQueryVariables, options?: C): Promise<GetValuesQuery> {
      return requester<GetValuesQuery, GetValuesQueryVariables>(GetValuesDocument, variables, options) as Promise<GetValuesQuery>;
    },
    getCardValuesData(variables: GetCardValuesDataQueryVariables, options?: C): Promise<GetCardValuesDataQuery> {
      return requester<GetCardValuesDataQuery, GetCardValuesDataQueryVariables>(GetCardValuesDataDocument, variables, options) as Promise<GetCardValuesDataQuery>;
    },
    getDashboardMetricsWithLabels(variables: GetDashboardMetricsWithLabelsQueryVariables, options?: C): Promise<GetDashboardMetricsWithLabelsQuery> {
      return requester<GetDashboardMetricsWithLabelsQuery, GetDashboardMetricsWithLabelsQueryVariables>(GetDashboardMetricsWithLabelsDocument, variables, options) as Promise<GetDashboardMetricsWithLabelsQuery>;
    },
    createOneMetric(variables: CreateOneMetricMutationVariables, options?: C): Promise<CreateOneMetricMutation> {
      return requester<CreateOneMetricMutation, CreateOneMetricMutationVariables>(CreateOneMetricDocument, variables, options) as Promise<CreateOneMetricMutation>;
    },
    updateOneMetric(variables: UpdateOneMetricMutationVariables, options?: C): Promise<UpdateOneMetricMutation> {
      return requester<UpdateOneMetricMutation, UpdateOneMetricMutationVariables>(UpdateOneMetricDocument, variables, options) as Promise<UpdateOneMetricMutation>;
    },
    deleteOneMetric(variables: DeleteOneMetricMutationVariables, options?: C): Promise<DeleteOneMetricMutation> {
      return requester<DeleteOneMetricMutation, DeleteOneMetricMutationVariables>(DeleteOneMetricDocument, variables, options) as Promise<DeleteOneMetricMutation>;
    },
    getMetricLabelVariants(variables: GetMetricLabelVariantsQueryVariables, options?: C): Promise<GetMetricLabelVariantsQuery> {
      return requester<GetMetricLabelVariantsQuery, GetMetricLabelVariantsQueryVariables>(GetMetricLabelVariantsDocument, variables, options) as Promise<GetMetricLabelVariantsQuery>;
    },
    mergeMetricLabel(variables: MergeMetricLabelMutationVariables, options?: C): Promise<MergeMetricLabelMutation> {
      return requester<MergeMetricLabelMutation, MergeMetricLabelMutationVariables>(MergeMetricLabelDocument, variables, options) as Promise<MergeMetricLabelMutation>;
    },
    getCardBasics(variables: GetCardBasicsQueryVariables, options?: C): Promise<GetCardBasicsQuery> {
      return requester<GetCardBasicsQuery, GetCardBasicsQueryVariables>(GetCardBasicsDocument, variables, options) as Promise<GetCardBasicsQuery>;
    },
    getCard(variables: GetCardQueryVariables, options?: C): Promise<GetCardQuery> {
      return requester<GetCardQuery, GetCardQueryVariables>(GetCardDocument, variables, options) as Promise<GetCardQuery>;
    },
    updateCard(variables: UpdateCardMutationVariables, options?: C): Promise<UpdateCardMutation> {
      return requester<UpdateCardMutation, UpdateCardMutationVariables>(UpdateCardDocument, variables, options) as Promise<UpdateCardMutation>;
    },
    deleteCard(variables?: DeleteCardMutationVariables, options?: C): Promise<DeleteCardMutation> {
      return requester<DeleteCardMutation, DeleteCardMutationVariables>(DeleteCardDocument, variables, options) as Promise<DeleteCardMutation>;
    },
    getLines(variables?: GetLinesQueryVariables, options?: C): Promise<GetLinesQuery> {
      return requester<GetLinesQuery, GetLinesQueryVariables>(GetLinesDocument, variables, options) as Promise<GetLinesQuery>;
    },
    getCards(variables: GetCardsQueryVariables, options?: C): Promise<GetCardsQuery> {
      return requester<GetCardsQuery, GetCardsQueryVariables>(GetCardsDocument, variables, options) as Promise<GetCardsQuery>;
    },
    getCardValues(variables: GetCardValuesQueryVariables, options?: C): Promise<GetCardValuesQuery> {
      return requester<GetCardValuesQuery, GetCardValuesQueryVariables>(GetCardValuesDocument, variables, options) as Promise<GetCardValuesQuery>;
    },
    getCardSyncValues(variables: GetCardSyncValuesQueryVariables, options?: C): Promise<GetCardSyncValuesQuery> {
      return requester<GetCardSyncValuesQuery, GetCardSyncValuesQueryVariables>(GetCardSyncValuesDocument, variables, options) as Promise<GetCardSyncValuesQuery>;
    },
    getCheckInTemplates(variables: GetCheckInTemplatesQueryVariables, options?: C): Promise<GetCheckInTemplatesQuery> {
      return requester<GetCheckInTemplatesQuery, GetCheckInTemplatesQueryVariables>(GetCheckInTemplatesDocument, variables, options) as Promise<GetCheckInTemplatesQuery>;
    },
    getCheckInTemplate(variables: GetCheckInTemplateQueryVariables, options?: C): Promise<GetCheckInTemplateQuery> {
      return requester<GetCheckInTemplateQuery, GetCheckInTemplateQueryVariables>(GetCheckInTemplateDocument, variables, options) as Promise<GetCheckInTemplateQuery>;
    },
    getCheckInInstance(variables: GetCheckInInstanceQueryVariables, options?: C): Promise<GetCheckInInstanceQuery> {
      return requester<GetCheckInInstanceQuery, GetCheckInInstanceQueryVariables>(GetCheckInInstanceDocument, variables, options) as Promise<GetCheckInInstanceQuery>;
    },
    getMyCheckIns(variables: GetMyCheckInsQueryVariables, options?: C): Promise<GetMyCheckInsQuery> {
      return requester<GetMyCheckInsQuery, GetMyCheckInsQueryVariables>(GetMyCheckInsDocument, variables, options) as Promise<GetMyCheckInsQuery>;
    },
    getCheckInResponses(variables: GetCheckInResponsesQueryVariables, options?: C): Promise<GetCheckInResponsesQuery> {
      return requester<GetCheckInResponsesQuery, GetCheckInResponsesQueryVariables>(GetCheckInResponsesDocument, variables, options) as Promise<GetCheckInResponsesQuery>;
    },
    getCheckInTrends(variables: GetCheckInTrendsQueryVariables, options?: C): Promise<GetCheckInTrendsQuery> {
      return requester<GetCheckInTrendsQuery, GetCheckInTrendsQueryVariables>(GetCheckInTrendsDocument, variables, options) as Promise<GetCheckInTrendsQuery>;
    },
    getLibraryQuestions(variables?: GetLibraryQuestionsQueryVariables, options?: C): Promise<GetLibraryQuestionsQuery> {
      return requester<GetLibraryQuestionsQuery, GetLibraryQuestionsQueryVariables>(GetLibraryQuestionsDocument, variables, options) as Promise<GetLibraryQuestionsQuery>;
    },
    getLibraryQuestion(variables: GetLibraryQuestionQueryVariables, options?: C): Promise<GetLibraryQuestionQuery> {
      return requester<GetLibraryQuestionQuery, GetLibraryQuestionQueryVariables>(GetLibraryQuestionDocument, variables, options) as Promise<GetLibraryQuestionQuery>;
    },
    createCheckInTemplate(variables: CreateCheckInTemplateMutationVariables, options?: C): Promise<CreateCheckInTemplateMutation> {
      return requester<CreateCheckInTemplateMutation, CreateCheckInTemplateMutationVariables>(CreateCheckInTemplateDocument, variables, options) as Promise<CreateCheckInTemplateMutation>;
    },
    updateCheckInTemplate(variables: UpdateCheckInTemplateMutationVariables, options?: C): Promise<UpdateCheckInTemplateMutation> {
      return requester<UpdateCheckInTemplateMutation, UpdateCheckInTemplateMutationVariables>(UpdateCheckInTemplateDocument, variables, options) as Promise<UpdateCheckInTemplateMutation>;
    },
    createCheckInInstance(variables: CreateCheckInInstanceMutationVariables, options?: C): Promise<CreateCheckInInstanceMutation> {
      return requester<CreateCheckInInstanceMutation, CreateCheckInInstanceMutationVariables>(CreateCheckInInstanceDocument, variables, options) as Promise<CreateCheckInInstanceMutation>;
    },
    updateCheckInInstance(variables: UpdateCheckInInstanceMutationVariables, options?: C): Promise<UpdateCheckInInstanceMutation> {
      return requester<UpdateCheckInInstanceMutation, UpdateCheckInInstanceMutationVariables>(UpdateCheckInInstanceDocument, variables, options) as Promise<UpdateCheckInInstanceMutation>;
    },
    selectDynamicQuestions(variables: SelectDynamicQuestionsMutationVariables, options?: C): Promise<SelectDynamicQuestionsMutation> {
      return requester<SelectDynamicQuestionsMutation, SelectDynamicQuestionsMutationVariables>(SelectDynamicQuestionsDocument, variables, options) as Promise<SelectDynamicQuestionsMutation>;
    },
    submitCheckInResponse(variables: SubmitCheckInResponseMutationVariables, options?: C): Promise<SubmitCheckInResponseMutation> {
      return requester<SubmitCheckInResponseMutation, SubmitCheckInResponseMutationVariables>(SubmitCheckInResponseDocument, variables, options) as Promise<SubmitCheckInResponseMutation>;
    },
    toggleFavoriteQuestion(variables: ToggleFavoriteQuestionMutationVariables, options?: C): Promise<ToggleFavoriteQuestionMutation> {
      return requester<ToggleFavoriteQuestionMutation, ToggleFavoriteQuestionMutationVariables>(ToggleFavoriteQuestionDocument, variables, options) as Promise<ToggleFavoriteQuestionMutation>;
    },
    createCheckInSlot(variables: CreateCheckInSlotMutationVariables, options?: C): Promise<CreateCheckInSlotMutation> {
      return requester<CreateCheckInSlotMutation, CreateCheckInSlotMutationVariables>(CreateCheckInSlotDocument, variables, options) as Promise<CreateCheckInSlotMutation>;
    },
    updateCheckInSlot(variables: UpdateCheckInSlotMutationVariables, options?: C): Promise<UpdateCheckInSlotMutation> {
      return requester<UpdateCheckInSlotMutation, UpdateCheckInSlotMutationVariables>(UpdateCheckInSlotDocument, variables, options) as Promise<UpdateCheckInSlotMutation>;
    },
    deleteCheckInSlot(variables: DeleteCheckInSlotMutationVariables, options?: C): Promise<DeleteCheckInSlotMutation> {
      return requester<DeleteCheckInSlotMutation, DeleteCheckInSlotMutationVariables>(DeleteCheckInSlotDocument, variables, options) as Promise<DeleteCheckInSlotMutation>;
    },
    deleteCheckInTemplate(variables: DeleteCheckInTemplateMutationVariables, options?: C): Promise<DeleteCheckInTemplateMutation> {
      return requester<DeleteCheckInTemplateMutation, DeleteCheckInTemplateMutationVariables>(DeleteCheckInTemplateDocument, variables, options) as Promise<DeleteCheckInTemplateMutation>;
    },
    createLibraryQuestion(variables: CreateLibraryQuestionMutationVariables, options?: C): Promise<CreateLibraryQuestionMutation> {
      return requester<CreateLibraryQuestionMutation, CreateLibraryQuestionMutationVariables>(CreateLibraryQuestionDocument, variables, options) as Promise<CreateLibraryQuestionMutation>;
    },
    updateLibraryQuestion(variables: UpdateLibraryQuestionMutationVariables, options?: C): Promise<UpdateLibraryQuestionMutation> {
      return requester<UpdateLibraryQuestionMutation, UpdateLibraryQuestionMutationVariables>(UpdateLibraryQuestionDocument, variables, options) as Promise<UpdateLibraryQuestionMutation>;
    },
    deleteLibraryQuestion(variables: DeleteLibraryQuestionMutationVariables, options?: C): Promise<DeleteLibraryQuestionMutation> {
      return requester<DeleteLibraryQuestionMutation, DeleteLibraryQuestionMutationVariables>(DeleteLibraryQuestionDocument, variables, options) as Promise<DeleteLibraryQuestionMutation>;
    },
    getQuestionTags(variables: GetQuestionTagsQueryVariables, options?: C): Promise<GetQuestionTagsQuery> {
      return requester<GetQuestionTagsQuery, GetQuestionTagsQueryVariables>(GetQuestionTagsDocument, variables, options) as Promise<GetQuestionTagsQuery>;
    },
    createQuestionTag(variables: CreateQuestionTagMutationVariables, options?: C): Promise<CreateQuestionTagMutation> {
      return requester<CreateQuestionTagMutation, CreateQuestionTagMutationVariables>(CreateQuestionTagDocument, variables, options) as Promise<CreateQuestionTagMutation>;
    },
    updateQuestionTag(variables: UpdateQuestionTagMutationVariables, options?: C): Promise<UpdateQuestionTagMutation> {
      return requester<UpdateQuestionTagMutation, UpdateQuestionTagMutationVariables>(UpdateQuestionTagDocument, variables, options) as Promise<UpdateQuestionTagMutation>;
    },
    deleteQuestionTag(variables: DeleteQuestionTagMutationVariables, options?: C): Promise<DeleteQuestionTagMutation> {
      return requester<DeleteQuestionTagMutation, DeleteQuestionTagMutationVariables>(DeleteQuestionTagDocument, variables, options) as Promise<DeleteQuestionTagMutation>;
    },
    createChurch(variables: CreateChurchMutationVariables, options?: C): Promise<CreateChurchMutation> {
      return requester<CreateChurchMutation, CreateChurchMutationVariables>(CreateChurchDocument, variables, options) as Promise<CreateChurchMutation>;
    },
    getChurchBySlug(variables: GetChurchBySlugQueryVariables, options?: C): Promise<GetChurchBySlugQuery> {
      return requester<GetChurchBySlugQuery, GetChurchBySlugQueryVariables>(GetChurchBySlugDocument, variables, options) as Promise<GetChurchBySlugQuery>;
    },
    getChurchSettings(variables?: GetChurchSettingsQueryVariables, options?: C): Promise<GetChurchSettingsQuery> {
      return requester<GetChurchSettingsQuery, GetChurchSettingsQueryVariables>(GetChurchSettingsDocument, variables, options) as Promise<GetChurchSettingsQuery>;
    },
    updateChurch(variables: UpdateChurchMutationVariables, options?: C): Promise<UpdateChurchMutation> {
      return requester<UpdateChurchMutation, UpdateChurchMutationVariables>(UpdateChurchDocument, variables, options) as Promise<UpdateChurchMutation>;
    },
    deleteIntegration(variables?: DeleteIntegrationMutationVariables, options?: C): Promise<DeleteIntegrationMutation> {
      return requester<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(DeleteIntegrationDocument, variables, options) as Promise<DeleteIntegrationMutation>;
    },
    getDashboardsPage(variables?: GetDashboardsPageQueryVariables, options?: C): Promise<GetDashboardsPageQuery> {
      return requester<GetDashboardsPageQuery, GetDashboardsPageQueryVariables>(GetDashboardsPageDocument, variables, options) as Promise<GetDashboardsPageQuery>;
    },
    getDashboardsBySlug(variables: GetDashboardsBySlugQueryVariables, options?: C): Promise<GetDashboardsBySlugQuery> {
      return requester<GetDashboardsBySlugQuery, GetDashboardsBySlugQueryVariables>(GetDashboardsBySlugDocument, variables, options) as Promise<GetDashboardsBySlugQuery>;
    },
    createDashboard(variables: CreateDashboardMutationVariables, options?: C): Promise<CreateDashboardMutation> {
      return requester<CreateDashboardMutation, CreateDashboardMutationVariables>(CreateDashboardDocument, variables, options) as Promise<CreateDashboardMutation>;
    },
    getDashboard(variables: GetDashboardQueryVariables, options?: C): Promise<GetDashboardQuery> {
      return requester<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, variables, options) as Promise<GetDashboardQuery>;
    },
    updateDashboard(variables: UpdateDashboardMutationVariables, options?: C): Promise<UpdateDashboardMutation> {
      return requester<UpdateDashboardMutation, UpdateDashboardMutationVariables>(UpdateDashboardDocument, variables, options) as Promise<UpdateDashboardMutation>;
    },
    getDashboardByChurchSlug(variables: GetDashboardByChurchSlugQueryVariables, options?: C): Promise<GetDashboardByChurchSlugQuery> {
      return requester<GetDashboardByChurchSlugQuery, GetDashboardByChurchSlugQueryVariables>(GetDashboardByChurchSlugDocument, variables, options) as Promise<GetDashboardByChurchSlugQuery>;
    },
    deleteDashboard(variables?: DeleteDashboardMutationVariables, options?: C): Promise<DeleteDashboardMutation> {
      return requester<DeleteDashboardMutation, DeleteDashboardMutationVariables>(DeleteDashboardDocument, variables, options) as Promise<DeleteDashboardMutation>;
    },
    getDepartments(variables: GetDepartmentsQueryVariables, options?: C): Promise<GetDepartmentsQuery> {
      return requester<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, variables, options) as Promise<GetDepartmentsQuery>;
    },
    createDepartment(variables: CreateDepartmentMutationVariables, options?: C): Promise<CreateDepartmentMutation> {
      return requester<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, variables, options) as Promise<CreateDepartmentMutation>;
    },
    updateDepartment(variables: UpdateDepartmentMutationVariables, options?: C): Promise<UpdateDepartmentMutation> {
      return requester<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, variables, options) as Promise<UpdateDepartmentMutation>;
    },
    deleteDepartment(variables: DeleteDepartmentMutationVariables, options?: C): Promise<DeleteDepartmentMutation> {
      return requester<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, variables, options) as Promise<DeleteDepartmentMutation>;
    },
    getDepartmentGraph(variables: GetDepartmentGraphQueryVariables, options?: C): Promise<GetDepartmentGraphQuery> {
      return requester<GetDepartmentGraphQuery, GetDepartmentGraphQueryVariables>(GetDepartmentGraphDocument, variables, options) as Promise<GetDepartmentGraphQuery>;
    },
    getDepartment(variables: GetDepartmentQueryVariables, options?: C): Promise<GetDepartmentQuery> {
      return requester<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, variables, options) as Promise<GetDepartmentQuery>;
    },
    getDepartmentMembers(variables: GetDepartmentMembersQueryVariables, options?: C): Promise<GetDepartmentMembersQuery> {
      return requester<GetDepartmentMembersQuery, GetDepartmentMembersQueryVariables>(GetDepartmentMembersDocument, variables, options) as Promise<GetDepartmentMembersQuery>;
    },
    getSubDepartments(variables: GetSubDepartmentsQueryVariables, options?: C): Promise<GetSubDepartmentsQuery> {
      return requester<GetSubDepartmentsQuery, GetSubDepartmentsQueryVariables>(GetSubDepartmentsDocument, variables, options) as Promise<GetSubDepartmentsQuery>;
    },
    getParentNames(variables: GetParentNamesQueryVariables, options?: C): Promise<GetParentNamesQuery> {
      return requester<GetParentNamesQuery, GetParentNamesQueryVariables>(GetParentNamesDocument, variables, options) as Promise<GetParentNamesQuery>;
    },
    getNamesWithParents(variables: GetNamesWithParentsQueryVariables, options?: C): Promise<GetNamesWithParentsQuery> {
      return requester<GetNamesWithParentsQuery, GetNamesWithParentsQueryVariables>(GetNamesWithParentsDocument, variables, options) as Promise<GetNamesWithParentsQuery>;
    },
    getSubDepartmentNames(variables: GetSubDepartmentNamesQueryVariables, options?: C): Promise<GetSubDepartmentNamesQuery> {
      return requester<GetSubDepartmentNamesQuery, GetSubDepartmentNamesQueryVariables>(GetSubDepartmentNamesDocument, variables, options) as Promise<GetSubDepartmentNamesQuery>;
    },
    getFields(variables: GetFieldsQueryVariables, options?: C): Promise<GetFieldsQuery> {
      return requester<GetFieldsQuery, GetFieldsQueryVariables>(GetFieldsDocument, variables, options) as Promise<GetFieldsQuery>;
    },
    createCustomField(variables: CreateCustomFieldMutationVariables, options?: C): Promise<CreateCustomFieldMutation> {
      return requester<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>(CreateCustomFieldDocument, variables, options) as Promise<CreateCustomFieldMutation>;
    },
    updateCustomField(variables: UpdateCustomFieldMutationVariables, options?: C): Promise<UpdateCustomFieldMutation> {
      return requester<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>(UpdateCustomFieldDocument, variables, options) as Promise<UpdateCustomFieldMutation>;
    },
    deleteCustomField(variables: DeleteCustomFieldMutationVariables, options?: C): Promise<DeleteCustomFieldMutation> {
      return requester<DeleteCustomFieldMutation, DeleteCustomFieldMutationVariables>(DeleteCustomFieldDocument, variables, options) as Promise<DeleteCustomFieldMutation>;
    },
    createMember(variables: CreateMemberMutationVariables, options?: C): Promise<CreateMemberMutation> {
      return requester<CreateMemberMutation, CreateMemberMutationVariables>(CreateMemberDocument, variables, options) as Promise<CreateMemberMutation>;
    },
    updateMember(variables: UpdateMemberMutationVariables, options?: C): Promise<UpdateMemberMutation> {
      return requester<UpdateMemberMutation, UpdateMemberMutationVariables>(UpdateMemberDocument, variables, options) as Promise<UpdateMemberMutation>;
    },
    deleteMember(variables: DeleteMemberMutationVariables, options?: C): Promise<DeleteMemberMutation> {
      return requester<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, variables, options) as Promise<DeleteMemberMutation>;
    },
    updateManyMembers(variables: UpdateManyMembersMutationVariables, options?: C): Promise<UpdateManyMembersMutation> {
      return requester<UpdateManyMembersMutation, UpdateManyMembersMutationVariables>(UpdateManyMembersDocument, variables, options) as Promise<UpdateManyMembersMutation>;
    },
    createActivity(variables: CreateActivityMutationVariables, options?: C): Promise<CreateActivityMutation> {
      return requester<CreateActivityMutation, CreateActivityMutationVariables>(CreateActivityDocument, variables, options) as Promise<CreateActivityMutation>;
    },
    updateActivity(variables: UpdateActivityMutationVariables, options?: C): Promise<UpdateActivityMutation> {
      return requester<UpdateActivityMutation, UpdateActivityMutationVariables>(UpdateActivityDocument, variables, options) as Promise<UpdateActivityMutation>;
    },
    deleteActivity(variables: DeleteActivityMutationVariables, options?: C): Promise<DeleteActivityMutation> {
      return requester<DeleteActivityMutation, DeleteActivityMutationVariables>(DeleteActivityDocument, variables, options) as Promise<DeleteActivityMutation>;
    },
    updatePersonInterval(variables: UpdatePersonIntervalMutationVariables, options?: C): Promise<UpdatePersonIntervalMutation> {
      return requester<UpdatePersonIntervalMutation, UpdatePersonIntervalMutationVariables>(UpdatePersonIntervalDocument, variables, options) as Promise<UpdatePersonIntervalMutation>;
    },
    deletePerson(variables: DeletePersonMutationVariables, options?: C): Promise<DeletePersonMutation> {
      return requester<DeletePersonMutation, DeletePersonMutationVariables>(DeletePersonDocument, variables, options) as Promise<DeletePersonMutation>;
    },
    getDuplicates(variables?: GetDuplicatesQueryVariables, options?: C): Promise<GetDuplicatesQuery> {
      return requester<GetDuplicatesQuery, GetDuplicatesQueryVariables>(GetDuplicatesDocument, variables, options) as Promise<GetDuplicatesQuery>;
    },
    getReports(variables: GetReportsQueryVariables, options?: C): Promise<GetReportsQuery> {
      return requester<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, variables, options) as Promise<GetReportsQuery>;
    },
    getReportInfo(variables: GetReportInfoQueryVariables, options?: C): Promise<GetReportInfoQuery> {
      return requester<GetReportInfoQuery, GetReportInfoQueryVariables>(GetReportInfoDocument, variables, options) as Promise<GetReportInfoQuery>;
    },
    getReportMembers(variables: GetReportMembersQueryVariables, options?: C): Promise<GetReportMembersQuery> {
      return requester<GetReportMembersQuery, GetReportMembersQueryVariables>(GetReportMembersDocument, variables, options) as Promise<GetReportMembersQuery>;
    },
    createReport(variables: CreateReportMutationVariables, options?: C): Promise<CreateReportMutation> {
      return requester<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, variables, options) as Promise<CreateReportMutation>;
    },
    updateReport(variables: UpdateReportMutationVariables, options?: C): Promise<UpdateReportMutation> {
      return requester<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, variables, options) as Promise<UpdateReportMutation>;
    },
    deleteReport(variables: DeleteReportMutationVariables, options?: C): Promise<DeleteReportMutation> {
      return requester<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, variables, options) as Promise<DeleteReportMutation>;
    },
    getUsers(variables?: GetUsersQueryVariables, options?: C): Promise<GetUsersQuery> {
      return requester<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, variables, options) as Promise<GetUsersQuery>;
    },
    deleteTeamMember(variables: DeleteTeamMemberMutationVariables, options?: C): Promise<DeleteTeamMemberMutation> {
      return requester<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>(DeleteTeamMemberDocument, variables, options) as Promise<DeleteTeamMemberMutation>;
    },
    inviteMember(variables: InviteMemberMutationVariables, options?: C): Promise<InviteMemberMutation> {
      return requester<InviteMemberMutation, InviteMemberMutationVariables>(InviteMemberDocument, variables, options) as Promise<InviteMemberMutation>;
    },
    createWidget(variables: CreateWidgetMutationVariables, options?: C): Promise<CreateWidgetMutation> {
      return requester<CreateWidgetMutation, CreateWidgetMutationVariables>(CreateWidgetDocument, variables, options) as Promise<CreateWidgetMutation>;
    },
    updateWidget(variables: UpdateWidgetMutationVariables, options?: C): Promise<UpdateWidgetMutation> {
      return requester<UpdateWidgetMutation, UpdateWidgetMutationVariables>(UpdateWidgetDocument, variables, options) as Promise<UpdateWidgetMutation>;
    },
    deleteWidget(variables: DeleteWidgetMutationVariables, options?: C): Promise<DeleteWidgetMutation> {
      return requester<DeleteWidgetMutation, DeleteWidgetMutationVariables>(DeleteWidgetDocument, variables, options) as Promise<DeleteWidgetMutation>;
    },
    createMetricEntry(variables: CreateMetricEntryMutationVariables, options?: C): Promise<CreateMetricEntryMutation> {
      return requester<CreateMetricEntryMutation, CreateMetricEntryMutationVariables>(CreateMetricEntryDocument, variables, options) as Promise<CreateMetricEntryMutation>;
    },
    updateMetricEntry(variables: UpdateMetricEntryMutationVariables, options?: C): Promise<UpdateMetricEntryMutation> {
      return requester<UpdateMetricEntryMutation, UpdateMetricEntryMutationVariables>(UpdateMetricEntryDocument, variables, options) as Promise<UpdateMetricEntryMutation>;
    },
    updateMultipleMetricEntries(variables: UpdateMultipleMetricEntriesMutationVariables, options?: C): Promise<UpdateMultipleMetricEntriesMutation> {
      return requester<UpdateMultipleMetricEntriesMutation, UpdateMultipleMetricEntriesMutationVariables>(UpdateMultipleMetricEntriesDocument, variables, options) as Promise<UpdateMultipleMetricEntriesMutation>;
    },
    deleteMetricEntry(variables: DeleteMetricEntryMutationVariables, options?: C): Promise<DeleteMetricEntryMutation> {
      return requester<DeleteMetricEntryMutation, DeleteMetricEntryMutationVariables>(DeleteMetricEntryDocument, variables, options) as Promise<DeleteMetricEntryMutation>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;